// see http://jsfiddle.net/ctesene/9f2rA/5/light/
export default angular.module('selectAllCheckboxLabeled', [])
  .directive('selectAllCheckboxLabeled', function () {
    return {
      replace: true,
      restrict: 'E',
      scope: {
        checkboxes: '=',
        allselected: '=allSelected',
        allclear: '=allClear',
        disableField: '='
      },
      template: `
      <div class="layout layout--auto u-mb-">
        <div class="layout__item">
          <a ng-click="!disableField && labeledMasterChange(true)" class="c-link c-link--primary">{{ 'select' | translateWith:'all' }}</a>
        </div>
        <div class="layout__item">
          <a ng-click="!disableField && labeledMasterChange(false)" class="c-link c-link--primary">{{ 'unselect' | translate }}</a>
        </div>
      </div>`,
      controller: function ($scope, $element) {
        $scope.labeledMasterChange = function (value) {
          $scope.master = value;
          $scope.masterChange();
        };

        $scope.masterChange = function () {
          if ($scope.master) {
            $scope.checkboxes.forEach(cb => cb.selected = true);
          } else {
            $scope.checkboxes.forEach(cb => cb.selected = false);
          }
        };

        $scope.$watch('checkboxes', function () {
          $scope.master = !!$scope.checkboxes.filter(cb => cb.selected).length;
        }, true);
      }
    };
  })



/** WEBPACK FOOTER **
 ** ./src/directives/selectAllCheckboxLabeled.js
 **/